export class ControlStatus
{
    constructor (public dirty: boolean, public invalid: boolean, public error?: string)
    {
    }
}
